import * as React from 'react';

import type {EmailAutomation as EmailAutomationFragment} from 'nutshell-graphql-types';

import styles from '../sales-automation-card-email.module.css';

type Props = {
    emailAutomation: EmailAutomationFragment;
};

/*
 * Component that represents a email card on the sales process. This card
 * can span multiple "columns" in the board UI, depending on the
 * `emailAutomation.exitsStage.id` property
 */
export class SalesAutomationCardEmailMailchimp extends React.PureComponent<Props> {
    render() {
        const {exitsStage, emailList} = this.props.emailAutomation;

        return (
            <React.Fragment>
                <div
                    className={exitsStage ? styles['card-border'] : styles['card-border--striped']}
                />
                <img
                    src='/include/images/integration-logos/mailchimp-freddy.png'
                    className={styles['mailchimp-logo']}
                />
                <div className={styles['title-container']}>
                    <div className={styles.title}>
                        {emailList ? (
                            <span>
                                Add to list: <strong>{emailList.name}</strong>
                            </span>
                        ) : (
                            <span className={styles['missing-list']}>
                                Oh no! We couldn’t find the list.
                            </span>
                        )}
                    </div>
                    <div className={styles.subtitle}>{this.getSubtitle()}</div>
                </div>
            </React.Fragment>
        );
    }

    getSubtitle() {
        const {exitsStage, emailList} = this.props.emailAutomation;

        if (!emailList) return null;

        return exitsStage ? (
            <span>
                Remove from this list after: <strong>{exitsStage.name}</strong>
            </span>
        ) : (
            'Keep in this list forever'
        );
    }
}
